import { z } from "zod"

import {
  branchIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

const lineSchema = z.object({
  lineId: entityIdSchema,
  account: z.string().trim().min(1).max(140),
  branchId: branchIdSchema,
  costCenter: z.string().trim().min(1).max(140),
  debitMinor: z.number().int().nonnegative(),
  creditMinor: z.number().int().nonnegative(),
}).strict().refine(
  (line) => (line.debitMinor === 0) !== (line.creditMinor === 0),
  { message: "Each line must be one-sided." },
)

export const lateAdjustmentPostV1Schema = z.object({
  adjustmentId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  branchId: branchIdSchema,
  sourceId: entityIdSchema,
  sourceVersion: z.number().int().positive(),
  configurationId: entityIdSchema,
  configurationVersion: z.number().int().positive(),
  postingDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  reason: z.string().trim().min(12).max(500),
  lines: z.array(lineSchema).min(2).max(100),
}).strict()

export const lateAdjustmentResultV1Schema = z.object({
  entityType: z.literal("financial_posting"),
  entityId: entityIdSchema,
  state: z.literal("posted"),
  version: z.literal(1),
  legalEntityId: legalEntityIdSchema,
  branchId: branchIdSchema,
  sourceType: z.enum(["stripe", "worklio", "inventory", "billing"]),
  sourceId: entityIdSchema,
  sourceVersion: z.number().int().positive(),
  originalEventAt: z.string().datetime({ offset: true }),
  originalPostingDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  adjustmentPostingDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  closedPeriodId: entityIdSchema,
  currency: z.string().regex(/^[A-Z]{3}$/),
  amountMinor: z.number().int().positive(),
  journalEntry: z.string().trim().min(1).max(140),
}).strict()

export type LateAdjustmentPostV1 = z.infer<typeof lateAdjustmentPostV1Schema>
export type LateAdjustmentResultV1 = z.infer<
  typeof lateAdjustmentResultV1Schema
>
